module.exports = __webpack_public_path__ + "static/media/Set-Icap_Logo _Blanco.b3256bd8.png";